import { datadogLogs, LogsEvent } from '@datadog/browser-logs';
import { redactActivationTokens } from '@rhg/utils/partner-activation';
import { getOrCreateTabId } from '@rhg/utils/tab-id';
import { getDatadogConfig } from '../config';

const TAB_ID_PROP = 'tab_id';

function beforeSend(event: LogsEvent) {
    event.view.url = redactActivationTokens(event.view.url);
    if (event.view.referrer) {
        event.view.referrer = redactActivationTokens(event.view.referrer);
    }
    return true;
}

export const initDatadogLogs = (): void => {
    const datadogConfig = getDatadogConfig(process.env.NEXT_PUBLIC_ENV);
    if (datadogConfig.env === 'local') {
        return;
    }
    datadogLogs.init({
        ...datadogConfig,
        silentMultipleInit: true,
        forwardConsoleLogs: [],
        forwardErrorsToLogs: true,
        beforeSend,
    });
    datadogLogs.setGlobalContextProperty(TAB_ID_PROP, getOrCreateTabId());
};
